import type { SelectChangeEvent } from "@mui/material";
import { OutlinedInput, Select } from "@mui/material";
import { truncate } from "lodash";
import type { ReactNode} from "react";
import { useState } from "react";

interface MultiSelectInputProps {
  id?: string;
  defaultValues: string[];
  disabled?: boolean;
  children: ReactNode[] | ReactNode;
  onInputChange?: (newValues: string[]) => void;
}
const MultiSelectInput = ({ id, defaultValues, onInputChange, children, disabled }: MultiSelectInputProps) => {
  const [selectValue, setSelectValue] = useState<string[]>(defaultValues);
  const handleChange = (event: SelectChangeEvent<string[]>): void => {
    const {
      target: { value },
    } = event;
    const newValues = typeof value === "string" ? value.split(",") : value;
    setSelectValue(newValues);
    if (onInputChange) {
      onInputChange(newValues);
    }
  };

  return (
    <Select<string[]>
      aria-labelledby={id}
      className="min-h-[2.5rem] w-full mt-2"
      input={<OutlinedInput placeholder="Select an option" size="small" />}
      multiple
      onChange={handleChange}
      readOnly={disabled}
      renderValue={(selected) => truncate(selected.join(", "), { length: 65 })}
      value={selectValue}
    >
      {children}
    </Select>
  );
};

export default MultiSelectInput;